// extracted by mini-css-extract-plugin
export var modalClose = "modal-wrapper-module--modal-close--14b65";
export var modalContainer = "modal-wrapper-module--modal-container--e93a3";
export var modalContent = "modal-wrapper-module--modal-content--ba0f5";
export var modalTitleContainer = "modal-wrapper-module--modal-title-container--14cd5";
export var modalWrapper = "modal-wrapper-module--modal-wrapper--80d32";
export var slideIn = "modal-wrapper-module--slide-in--0cb19";